import React, { useState, useRef, useEffect } from "react";
import "./Products.css";
import { IoAddCircleSharp } from "react-icons/io5";
import { BsFolderPlus } from "react-icons/bs";
import { MdDeleteForever } from "react-icons/md";
import axios from "axios";

function Products({ products, fetchprod }) {
  const [pvproduct, setpvproduct] = useState({
    category: "",
    brand: "",
    prod_name: "",
    prod_desc: "",
    prod_size: "",
    features: "",
    Key_value: "",
    delivery_time: "",
    status: "",
    return: false,
    returnDays: "",
    payment: [],
  });
  const [prodDetails, setProdDetails] = useState([]);
  const [installationCard, setInstallationCard] = useState({
    hasEnable: false,
    price: "",
    desc: ""
  });
  const [newProduct, setNewProduct] = useState({
    category: "",
    brand: "",
    prod_name: "",
    prod_desc: "",
    features: "",
    Keywords: "",
    delivery_time: "",
    status: "active",
  });
  const [returnDays, setReturnDays] = useState("");
  const [Addmore, setAddmore] = useState(false);
  const [hasReturn, setHasReturn] = useState(false);
  const [hasinstallationCard, setHasinstallationCard] = useState(false);
  const [installationCardInfo, setInstallationCardInfo] = useState({
    price: "",
    desc: ""
  });

  const VendorDetails = JSON.parse(localStorage.getItem("vendorData"))

  // payment
  const paymentOptions = [
    "Credit/Debit Card",
    "Net Banking",
    "UPI",
    "Wallets (Paytm Google Pay etc.)",
    "Cash on Delivery",
    "EMI",
  ];

  const [selectedPayments, setSelectedPayments] = useState([]);

  const toggleSelection = (option) => {
    setSelectedPayments((prev) =>
      prev.includes(option)
        ? prev.filter((item) => item !== option)
        : [...prev, option]
    );
  };

  const [sizeData, setSizeData] = useState({});
  const [prevProduct, setPrevProduct] = useState(null);

  const sizeOptions = ["S", "M", "L", "XL", "XXL", "Free Size"];
  const [rows, setRows] = useState([]);

  const addRow = (e, type) => {
    e.preventDefault();
    if (type === "new") {
      setRows([
        ...rows,
        {
          size: "",
          price: "",
          discount: "",
          stock: "",
          net: "",
          Tax: "",
          total: "",
        }
      ]);
    } else {
      setProdDetails(prev => [
        ...prev,
        {
          prod_size: "",
          prod_price: 0,
          prod_discount: 0,
          discounted_amount: 0,
          tax: 0,
          total_amount: 0,
          stock: 0
        }
      ]);
    }
  };

  const updateRow = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;

    const price = Number(updated[index].price) || 0;
    const discount = Number(updated[index].discount) || 0;
    const tax = Number(updated[index].tax) || 0;

    // 1️⃣ Net price (after discount)
    let netPrice = price;
    if (discount > 0) {
      netPrice = price - (price * discount) / 100;
    }

    // 2️⃣ Tax amount (percentage of net price)
    const taxAmount = (netPrice * tax) / 100;

    // 3️⃣ Total price
    const total = netPrice + taxAmount;

    updated[index].net = netPrice ? netPrice.toFixed(2) : "";
    updated[index].total = total ? total.toFixed(2) : "";

    setRows(updated);
  };


  const removeRow = (index) => {
    setRows(rows.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (!prevProduct) return;
    const {
      prod_size = [],
      prod_price = [],
      prod_discount = [],
      discounted_amount = [],
      stock = [],
    } = prevProduct;

    const structured = {};
    prod_size.forEach((size, i) => {
      structured[size] = {
        enabled: true,
        price: prod_price[i] || "",
        discount: prod_discount[i] || "",
        net: discounted_amount[i] || "",
        stock: stock[i] || "",
      };
    });

    setSizeData(structured);
  }, [prevProduct]);

  const calculateAmounts = (price, discount, tax) => {
    const discounted_amount =
      price - (price * (discount || 0)) / 100;

    const total_amount =
      discounted_amount + (discounted_amount * (tax || 0)) / 100;

    return {
      discounted_amount: Number(discounted_amount.toFixed(2)),
      total_amount: Number(total_amount.toFixed(2))
    };
  };

  const updateSizeData = (size, field, value) => {
    const price =
      field === "price" ? parseFloat(value) : parseFloat(sizeData[size].price);
    const discount =
      field === "discount"
        ? parseFloat(value)
        : parseFloat(sizeData[size].discount);

    const net =
      price && discount ? (price - price * (discount / 100)).toFixed(2) : "";

    setSizeData((prev) => ({
      ...prev,
      [size]: {
        ...prev[size],
        [field]: value,
        net,
      },
    }));
  };

  const isPdfFile = (src) => {
    return src.toLowerCase().endsWith(".pdf");
  };

  const isVideoFile = (filename) => {
    const videoExts = ["mp4", "webm", "ogg"];
    const ext = filename.split(".").pop().toLowerCase();
    return videoExts.includes(ext);
  };

  const deleteImageFromServer = async (url) => {
    const filename = url.split("/").pop();
    const formData = new FormData();
    formData.append("filename", filename);
    formData.append("product_id", prevProduct?.product_id);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/prod_img_delete.php`,
        formData
      );

      if (res.data?.success) {
        console.log("Image deleted:", filename);
        fetchprod();
      } else {
        console.warn(
          "Server responded but did not confirm deletion:",
          res.data
        );
      }
    } catch (error) {
      console.error("Failed to delete image:", error);
    }
  };

  const handleRemoveMainPreview = (indexToRemove) => {
    const totalMedia = mediaUrls.length;

    if (indexToRemove < totalMedia) {
      const fileToDelete = mediaUrls[indexToRemove];
      deleteImageFromServer(fileToDelete);

      const updated = mediaUrls.filter((_, i) => i !== indexToRemove);
      setMediaUrls(updated);

      const totalRemaining = updated.length + previews.length;
      if (totalRemaining === 0) {
        setMainPreviewIndex(null);
      } else {
        setMainPreviewIndex(
          indexToRemove >= totalRemaining ? totalRemaining - 1 : indexToRemove
        );
      }
    } else {
      const previewIndex = indexToRemove - totalMedia;
      const updated = previews.filter((_, i) => i !== previewIndex);
      setPreviews(updated);

      const totalRemaining = mediaUrls.length + updated.length;
      if (totalRemaining === 0) {
        setMainPreviewIndex(null);
      } else {
        setMainPreviewIndex(
          indexToRemove >= totalRemaining ? totalRemaining - 1 : indexToRemove
        );
      }
    }
  };

  const [filesToUpload, setFilesToUpload] = useState([]);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const newPreviews = files.map((file) => URL.createObjectURL(file));

    setPreviews((prev) => [...prev, ...newPreviews]);
    setFilesToUpload((prev) => [...prev, ...files]);

    if (mainPreviewIndex === null && newPreviews.length > 0) {
      setMainPreviewIndex(mediaUrls.length); // starts from after existing
    }
  };

  const handleThumbnailClick = (index) => {
    setMainPreviewIndex(index);
  };

  const productdel = async (id) => {
    const formData = new FormData();
    formData.append("product_id", id);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/prod_delete.php`,
        formData
      );

      if (res.data?.success) {
        await fetchprod();

        console.log("Product deleted Successful");
      } else {
        console.warn(
          "Server responded but did not confirm deletion:",
          res.data
        );
      }
    } catch (error) {
      console.error("Failed to delete image:", error);
    }
  };

  const updateprod = async (id) => {
    const formData = new FormData();

    const product_details = prodDetails.map((row, index) => ({
      prod_size: row.prod_size ?? prevProduct?.prod_details?.[index]?.prod_size,
      prod_price: row.prod_price ?? prevProduct?.prod_details?.[index]?.prod_price,
      prod_discount: row.prod_discount ?? prevProduct?.prod_details?.[index]?.prod_discount,
      discounted_amount: row.discounted_amount ?? prevProduct?.prod_details?.[index]?.discounted_amount,
      stock: row.stock ?? prevProduct?.prod_details?.[index]?.stock,
      tax: row.tax ?? prevProduct?.prod_details?.[index]?.tax,
      total_amount: row.total_amount ?? prevProduct?.prod_details?.[index]?.total_amount,
      taxable_amount: row.taxable_amount ?? prevProduct?.prod_details?.[index]?.taxable_amount,
    }));


    formData.append("id", prevProduct?.id);
    formData.append("vendor_id", VendorDetails?.id);
    formData.append("category", pvproduct.category || prevProduct.category);
    formData.append("brand", pvproduct.brand || prevProduct.brand);
    formData.append("prod_name", pvproduct.prod_name || prevProduct.prod_name);
    formData.append("prod_desc", pvproduct.prod_desc || prevProduct.prod_desc);
    formData.append("features", pvproduct.features || prevProduct.features);
    formData.append("key_value", pvproduct.Key_value || prevProduct.key_value);

    if (pvproduct.return) {
      formData.append("return_policy", pvproduct.returnDays || "0");
    } else {
      formData.append("return_policy", "no return");
    }
    formData.append(
      "deliver_time",
      pvproduct.delivery_time || prevProduct.delivery_time
    );
    formData.append("status", pvproduct.status || prevProduct.status);
    formData.append(
      "payment[]",
      (pvproduct.payment || prevProduct.payment)?.join(",")
    );
    formData.append("prod_details", JSON.stringify(product_details));
    formData.append("rate_desc[]", installationCard?.desc);
    formData.append("rate_price[]", installationCard?.price);
    const existingNames = mediaUrls
      .filter((url) => typeof url === "string" && url.length > 0)
      .map((url) => url.split("/").pop());
    if (filesToUpload && filesToUpload.length > 0) {
      filesToUpload.forEach((file) => {
        formData.append("image_string[]", file);
      });
    }
    if (existingNames.length > 0) {
      formData.append("existing_images", existingNames.join(","));
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/prod_update.php`,
        formData
      );

      if (
        res.data?.success ||
        (res.data?.message &&
          res.data.message.toLowerCase().includes("success"))
      ) {
        await fetchprod();
        setIsEditable(false);
        setUpdatedId(id);
        setpvproduct({});
        setPreviews([]);
        setMainPreviewIndex(null);
        setFilesToUpload([]);
      } else if (res.data?.message === "No data changed") {
        setIsEditable(false);
        console.log("✅ No changes on product");
      } else {
        console.warn("⚠️ Update not confirmed:", res.data);
      }
    } catch (error) {
      console.error("❌ Failed to update product:", error);
    }
  };

  const [mediaUrls, setMediaUrls] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [mainPreviewIndex, setMainPreviewIndex] = useState(null);
  const [isEditable, setIsEditable] = useState(false);
  const fileInputRef = useRef(null);
  const [updatedId, setUpdatedId] = useState(null);

  useEffect(() => {
    if (prevProduct?.prod_img) {
      const files = prevProduct.prod_img
        .split(",")
        .map((file) => file.trim())
        .filter((f) => f);
      const urls = files.map(
        (file) =>
          `${process.env.REACT_APP_BASEURL}/apis/vendor/uploads/products/${file}`
      );
      setMediaUrls(urls);
      setMainPreviewIndex(0);
    }
  }, [prevProduct]);

  const allPreviews = [...mediaUrls, ...previews];

  useEffect(() => {
    if (prevProduct) {
      setpvproduct((prev) => ({
        ...prev,
        category: prevProduct.category || "",
        brand: prevProduct.brand || "",
        prod_name: prevProduct.prod_name || "",
        prod_desc: prevProduct.prod_desc || "",
        features: prevProduct.features || "",
        Key_value: prevProduct.key_value || "",
        delivery_time: prevProduct.delivery_time || "",
        status: prevProduct.status || "",
        return: prevProduct.return === 1,
        returnDays: prevProduct.return_policy || "",
        payment: Array.isArray(prevProduct.payment)
          ? prevProduct.payment.map((p) => p.trim())
          : typeof prevProduct.payment === "string"
            ? prevProduct.payment.split(",").map(p => p.trim())
            : [],
      }));
      if (Array.isArray(prevProduct?.prod_details)) {
        setProdDetails(prevProduct?.prod_details);
      }
      if ((Array.isArray(prevProduct?.rate_card)) && (prevProduct?.rate_card?.length > 0)) {

        setInstallationCard({
          hasEnable: true,
          price: prevProduct?.rate_card[0]?.price,
          desc: prevProduct?.rate_card[0]?.description,
        })
      }
    }
  }, [prevProduct]);

  useEffect(() => {
    if (updatedId && products.length > 0) {
      const refreshedProduct = products.find((p) => p.product_id === updatedId);
      if (refreshedProduct) {
        setPrevProduct(refreshedProduct);
        setUpdatedId(null);
      }
    }
  }, [updatedId, products]);

  const addProduct = async () => {
    const formData = new FormData();

    // Filter valid rows (size + price required)
    const validRows = rows.filter(
      (r) => r.size && r.price
    );

    if (validRows.length === 0) {
      alert("Please add at least one size");
      return;
    }

    const sizes = validRows.map((r) => r.size);
    const prices = validRows.map((r) => r.price);
    const discounts = validRows.map((r) => r.discount || 0);
    const nets = validRows.map((r) => r.net || 0);
    const stocks = validRows.map((r) => r.stock || 0);

    formData.append("vendor_id", "1");
    formData.append("category", newProduct.category || "");
    formData.append("brand", newProduct.brand || "");
    formData.append("prod_name", newProduct.prod_name || "");
    formData.append("prod_desc", newProduct.prod_desc || "");

    // 👇 IMPORTANT (backend expects comma-separated)
    formData.append("prod_size[]", sizes.join(","));
    formData.append("prod_price[]", prices.join(","));
    formData.append("prod_discount[]", discounts.join(","));
    formData.append("discounted_amount[]", nets.join(","));
    formData.append("stock[]", stocks.join(","));

    formData.append("features", newProduct.features || "");
    formData.append("key_value", newProduct.Keywords || "");
    formData.append("deliver_time", newProduct.delivery_time || "");
    formData.append(
      "return_policy",
      hasReturn ? returnDays || "0" : "no return"
    );
    formData.append("status", newProduct.status || "inactive");
    formData.append("payment", selectedPayments.join(","));

    formData.append("rate_price", installationCardInfo.price || "N/A");
    formData.append("rate_desc", installationCardInfo.desc || "N/A");

    if (filesToUpload?.length > 0) {
      filesToUpload.forEach((file) => {
        formData.append("image_string[]", file);
      });
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/prod_add.php`,
        formData
      );
      if (
        res.data?.success ||
        res.data?.message?.toLowerCase().includes("success")
      ) {
        await fetchprod();
        setNewProduct({
          category: "",
          brand: "",
          prod_name: "",
          prod_desc: "",
          features: "",
          Keywords: "",
          delivery_time: "",
          status: "active",
        });
        setFilesToUpload([]);
        setPreviews([]);
        setMainPreviewIndex(null);
        setSelectedPayments([]);
        setHasReturn(false);
        setReturnDays("");
        setAddmore(false);
        const resetSizeData = {};
        sizeOptions.forEach((size) => {
          resetSizeData[size] = {
            enabled: false,
            price: "",
            discount: "",
            net: "",
            stock: "",
          };
        });
        setSizeData(resetSizeData);
        console.log("✅ Product added successfully");
      } else if (
        res?.data?.message === "At least one product image is required"
      ) {
        alert("Select atleast one image to Upload");
      } else {
        console.warn("⚠️ Add not confirmed:", res.data);
      }
    } catch (error) {
      console.error("❌ Failed to add product:", error);
    }
  };

  const handleRemoveMainsPreview = () => {
    if (mainPreviewIndex !== null) {
      const newPreviews = [...previews];
      newPreviews.splice(mainPreviewIndex, 1);
      setPreviews(newPreviews);
      setFilesToUpload((prev) => {
        const newFiles = [...prev];
        newFiles.splice(mainPreviewIndex, 1);
        return newFiles;
      });

      // Reset index if list is now empty or index was last item
      if (newPreviews.length === 0 || mainPreviewIndex >= newPreviews.length) {
        setMainPreviewIndex(null);
      } else {
        setMainPreviewIndex(0);
      }
    }
  };

  // useEffect(() => {
  //   if(isEditable){
  //     fetchprod();
  //   }
  // }, [isEditable])

  const canceledit = () => {
    if (isEditable) {
      fetchprod();
      setFilesToUpload([]);

      setPrevProduct(null);
      setIsEditable(false);
    } else {
      setIsEditable(false);
      setPrevProduct(null);
    }
  };

  return (
    <div>
      <h1 className="dashboard-heading">Our Products</h1>

      <div
        className="products-summary-cards"
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          margin: "30px",
        }}
      >
        <div className="summary-card total">
          <div className="summary-title">Total Products</div>
          <div className="summary-value">{products.length}</div>
        </div>
        <div className="summary-card active">
          <div className="summary-title">Active</div>
          <div className="summary-value">
            {products.filter((item) => item.status === "active").length}
          </div>
        </div>
        <div className="summary-card inactive">
          <div className="summary-title">Inactive</div>
          <div className="summary-value">
            {products.filter((item) => item.status === "inactive").length}
          </div>
        </div>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {Array.isArray(products) && products.length > 0
          ? products.map((item, index) => (
            <div
              key={index}
              className="card-wrapper"
              onClick={() => setPrevProduct(item)}
            >
              <div className="card-box">
                {item.status === "inactive" ? (
                  <div>
                    <div className="card-badge inactive">inactive</div>
                  </div>
                ) : null}
                <div
                  className="delete"
                  title="Delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    productdel(item.product_id);
                  }}
                >
                  {" "}
                  <MdDeleteForever />
                </div>
                <div className="card-image-wrapper">
                  <img
                    src={`${process.env.REACT_APP_BASEURL
                      }/apis/vendor/uploads/products/${item.prod_img?.split(",")[0]}`}
                    alt={item.prod_name}
                    className="card-img"
                  />
                </div>

                <div className="card-info">
                  <div className="card-title">{item.product_id}</div>
                  <span className="card-subtitle">{item.prod_name}</span>
                </div>
              </div>
            </div>
          ))
          : null}

        <div className="card-wrapper">
          <div className="card-box add" onClick={() => setAddmore(true)}>
            <div className="add-more-icon">
              <IoAddCircleSharp />
            </div>
            <h3>Add More</h3>
          </div>
        </div>
      </div>

      {prevProduct && (
        <>
          <div className="modal-overlay" onClick={canceledit} />
          {/* {showCancelConfirm && (
            <div className="confirm-overlay">
              <div className="confirm-box">
                <p>
                  The product is in edit mode. Are you sure you want to cancel?
                </p>
                <button
                  onClick={() => {
                    setShowCancelConfirm(false);
                    setPrevProduct(null);
                    setIsEditable(false);
                  }}
                >
                  Yes, Cancel
                </button>
                <button onClick={() => setShowCancelConfirm(false)}>
                  No, Stay
                </button>
              </div>
            </div>
          )} */}

          <div
            className="add-more-modal large"
            onClick={(e) => e.stopPropagation()}
          >
            <h2>{prevProduct?.product_id}-{prevProduct?.prod_name}</h2>
            <div className="table-header">
              <button
                className="edit-btn"
                onClick={() => setIsEditable((prev) => !prev)}
              >
                {isEditable ? (
                  <span>
                    <span style={{ marginRight: 5 }}>❌</span>Cancel
                  </span>
                ) : (
                  <span>
                    <span style={{ marginRight: 5 }}>✏️</span>Edit
                  </span>
                )}
              </button>
            </div>
            <div>
              {/* first set  */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "30px",
                }}
              >
                {/* LEFT SIDE: IMAGE UPLOAD */}

                <div>
                  <div className="upload-box">
                    {allPreviews.length > 0 &&
                      mainPreviewIndex !== null &&
                      allPreviews[mainPreviewIndex] ? (
                      <div className="main-preview-wrapper">
                        {isVideoFile(allPreviews[mainPreviewIndex]) ? (
                          <video
                            src={allPreviews[mainPreviewIndex]}
                            className="main-preview-image"
                            controls
                          />
                        ) : isPdfFile(allPreviews[mainPreviewIndex]) ? (
                          <iframe
                            src={allPreviews[mainPreviewIndex]}
                            title="PDF Preview"
                            className="main-preview-image"
                          />
                        ) : (
                          <img
                            src={allPreviews[mainPreviewIndex]}
                            alt="Main preview"
                            className="main-preview-image"
                          />
                        )}


                        {isEditable && (
                          <div className="preview-controls">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveMainPreview(mainPreviewIndex);
                              }}
                            >
                              Remove
                            </button>
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>

                  {/* Thumbnails */}
                  <div className="preview-list">
                    {allPreviews.map((src, i) => (
                      <div
                        key={i}
                        className="preview-thumb"
                        onClick={() => setMainPreviewIndex(i)}
                        title="Click to set as main preview"
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {isPdfFile(src) ? (
                          <div className="pdf-preview">
                            📄
                            <span>PDF</span>
                          </div>
                        ) : isVideoFile(src) ? (
                          <video
                            src={src}
                            muted
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <img
                            src={src}
                            alt={`preview-${i}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        )}
                      </div>
                    ))}


                    {isEditable && (
                      <div
                        className="preview-thumb"
                        onClick={() => fileInputRef.current?.click()}
                        title="Click to add new image"
                        style={{
                          border: "2px dashed #aaa",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "24px",
                          color: "#999",
                          cursor: "pointer",
                        }}
                      >
                        <BsFolderPlus className="upload-icon" size={28} />
                      </div>
                    )}

                    <input
                      type="file"
                      accept="image/*,video/*,application/pdf"
                      multiple
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </div>
                </div>

                {/* RIGHT SIDE: PRODUCT INFO */}
                <div style={{ width: "100%", maxWidth: "600px" }}>
                  <div className="row">
                    <div>
                      <label className="field-title">Category</label>
                      {isEditable ? (
                        <select
                          value={pvproduct.category}
                          onChange={(e) =>
                            setpvproduct((prev) => ({
                              ...prev,
                              category: e.target.value,
                            }))
                          }
                        >
                          <option value="" disabled>
                            Select Category
                          </option>
                          <option value="electronics">Electronics</option>
                          <option value="fashion">Fashion</option>
                          <option value="grocery">Grocery</option>
                          <option value="home">Home</option>
                        </select>
                      ) : (
                        <input
                          type="text"
                          value={prevProduct?.category || ""}
                          readOnly
                        />
                      )}
                    </div>

                    <div>
                      <label className="field-title">Brand</label>
                      <input
                        type="text"
                        value={
                          isEditable
                            ? pvproduct.brand
                            : prevProduct?.brand || ""
                        }
                        onChange={(e) => {
                          if (isEditable) {
                            setpvproduct((prev) => ({
                              ...prev,
                              brand: e.target.value,
                            }));
                          }
                        }}
                        readOnly={!isEditable}
                      />
                    </div>
                  </div>

                  <label className="field-title">Product Name</label>
                  <input
                    type="text"
                    value={
                      isEditable
                        ? pvproduct.prod_name
                        : prevProduct?.prod_name || ""
                    }
                    onChange={(e) => {
                      if (isEditable) {
                        setpvproduct((prev) => ({
                          ...prev,
                          prod_name: e.target.value,
                        }));
                      }
                    }}
                    readOnly={!isEditable}
                  />

                  <label className="field-title">Description</label>
                  <textarea
                    className="textarea"
                    value={
                      isEditable
                        ? pvproduct.prod_desc
                        : prevProduct?.prod_desc || ""
                    }
                    onChange={(e) => {
                      if (isEditable) {
                        setpvproduct((prev) => ({
                          ...prev,
                          prod_desc: e.target.value,
                        }));
                      }
                    }}
                    readOnly={!isEditable}
                  />

                  <label className="field-title">Features</label>
                  <textarea
                    className="textarea"
                    value={
                      isEditable
                        ? pvproduct.features
                        : prevProduct?.features || ""
                    }
                    onChange={(e) => {
                      if (isEditable) {
                        setpvproduct((prev) => ({
                          ...prev,
                          features: e.target.value,
                        }));
                      }
                    }}
                    readOnly={!isEditable}
                  />

                  <div>
                    <label className="field-title">Keywords / Hashtags</label>
                    <textarea
                      className="textarea"
                      value={
                        isEditable
                          ? pvproduct.Key_value
                          : prevProduct?.key_value || ""
                      }
                      onChange={(e) => {
                        if (isEditable) {
                          setpvproduct((prev) => ({
                            ...prev,
                            Key_value: e.target.value,
                          }));
                        }
                      }}
                      readOnly={!isEditable}
                    />
                  </div>
                </div>
              </div>

              {/* size table  */}
              <div className="size-pricing-table">
                <h3 className="field-title">Size Pricing</h3>
                {isEditable && (
                  <button
                    onClick={(e) => addRow(e, "old")}
                    disabled={!isEditable}
                  >
                    ➕ Add Size
                  </button>
                )}

                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Size</th>
                      <th>Original Price</th>
                      <th>Discount (%)</th>
                      <th>Discounted amount</th>
                      <th>Tax</th>
                      <th>Total Price</th>
                      <th>Stock</th>
                      {isEditable && (
                        <th>Action</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {prodDetails.map((item, index) => (
                      <tr key={index}>
                        {/* Size */}
                        <td>
                          {isEditable ? (
                            <input
                              type="text"
                              value={item.prod_size}
                              onChange={(e) => {
                                const size = e.target.value;
                                setProdDetails(prev =>
                                  prev.map((row, i) =>
                                    i === index ? { ...row, prod_size: size } : row
                                  )
                                );
                              }}
                            />
                          ) : (
                            <input type="text" value={item.prod_size} readOnly />
                          )}
                        </td>

                        {/* Price */}
                        <td>
                          <input
                            type="number"
                            value={item.prod_price}
                            disabled={!isEditable}
                            onChange={(e) => {
                              const price = Number(e.target.value);
                              setProdDetails(prev =>
                                prev.map((row, i) =>
                                  i === index
                                    ? {
                                      ...row,
                                      prod_price: price,
                                      ...calculateAmounts(price, row.prod_discount, row.tax)
                                    }
                                    : row
                                )
                              );
                            }}
                          />
                        </td>

                        {/* Discount */}
                        <td>
                          <input
                            type="number"
                            value={item.prod_discount}
                            disabled={!isEditable}
                            onChange={(e) => {
                              const discount = Number(e.target.value);
                              setProdDetails(prev =>
                                prev.map((row, i) =>
                                  i === index
                                    ? {
                                      ...row,
                                      prod_discount: discount,
                                      ...calculateAmounts(row.prod_price, discount, row.tax)
                                    }
                                    : row
                                )
                              );
                            }}
                          />
                        </td>

                        {/* Discounted */}
                        <td>
                          <input readOnly value={item.discounted_amount} />
                        </td>

                        {/* Tax */}
                        <td>
                          <input
                            type="number"
                            value={item.tax}
                            disabled={!isEditable}
                            onChange={(e) => {
                              const tax = Number(e.target.value);
                              setProdDetails(prev =>
                                prev.map((row, i) =>
                                  i === index
                                    ? {
                                      ...row,
                                      tax,
                                      ...calculateAmounts(row.prod_price, row.prod_discount, tax)
                                    }
                                    : row
                                )
                              );
                            }}
                          />
                        </td>

                        {/* Total */}
                        <td>
                          <input readOnly value={item.total_amount} />
                        </td>

                        {/* Stock */}
                        <td>
                          <input
                            type="number"
                            value={item.stock}
                            disabled={!isEditable}
                            onChange={(e) => {
                              const stock = Number(e.target.value);
                              setProdDetails(prev =>
                                prev.map((row, i) =>
                                  i === index ? { ...row, stock } : row
                                )
                              );
                            }}
                          />
                        </td>

                        {/* Action */}
                        {isEditable && (
                          <td>
                            <button
                              disabled={!isEditable}
                              onClick={() =>
                                setProdDetails(prev =>
                                  prev.filter((_, i) => i !== index)
                                )
                              }
                            >
                              Remove
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* 2nd set  */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "30px",
                }}
              >
                <div style={{ width: "100%", maxWidth: "600px" }}>
                  {/* Payment Methods */}
                  <div className="payment-methods">
                    <h3 className="field-title">Accepted Payment Methods</h3>
                    <div className="payment-grid">
                      {paymentOptions.map((option, index) => (
                        <label
                          key={index}
                          className={`payment-card ${pvproduct.payment?.includes(option)
                            ? "selected"
                            : ""
                            }`}
                        >
                          <input
                            type="checkbox"
                            value={option}
                            checked={pvproduct.payment?.includes(option)}
                            onChange={() => {
                              if (!isEditable) return;

                              const updated = pvproduct.payment?.includes(
                                option
                              )
                                ? pvproduct.payment.filter((p) => p !== option)
                                : [...(pvproduct.payment || []), option];

                              setpvproduct((prev) => ({
                                ...prev,
                                payment: updated,
                              }));
                            }}
                          />
                          {option}
                          {pvproduct.payment?.includes(option) && (
                            <span className="checkmark">✔</span>
                          )}
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Return Policy */}
                  <label className="field-title">Return Policy</label>
                  <div className="return-policy-toggle">
                    <input
                      className="return-checkbox"
                      type="checkbox"
                      id="returnCheckbox"
                      checked={pvproduct.return}
                      disabled={!isEditable}
                      onChange={(e) =>
                        setpvproduct((prev) => ({
                          ...prev,
                          return: e.target.checked,
                        }))
                      }
                    />
                    <label
                      htmlFor="returnCheckbox"
                      style={{ textWrap: "nowrap", paddingRight: "20px" }}
                    >
                      Enable Returns
                    </label>

                    {pvproduct.return && (
                      <input
                        type="number"
                        min={1}
                        max={30}
                        value={pvproduct.returnDays}
                        disabled={!isEditable}
                        onChange={(e) =>
                          setpvproduct((prev) => ({
                            ...prev,
                            returnDays: e.target.value,
                          }))
                        }
                        placeholder="Return Policy Days"
                        className="return-days-input"
                      />
                    )}
                  </div>
                </div>

                <div style={{ width: "100%", maxWidth: "600px" }}>
                  {/* Delivery Time */}
                  <label className="field-title">Delivery Time (in Days)</label>
                  <input
                    type="text"
                    value={
                      isEditable
                        ? pvproduct.delivery_time
                        : prevProduct?.delivery_time || ""
                    }
                    onChange={(e) => {
                      if (isEditable) {
                        setpvproduct((prev) => ({
                          ...prev,
                          delivery_time: e.target.value,
                        }));
                      }
                    }}
                    readOnly={!isEditable}
                  />

                  {/* Product Status */}
                  <label className="field-title">Product Status</label>
                  {isEditable ? (
                    <select
                      value={pvproduct.status}
                      onChange={(e) =>
                        setpvproduct((prev) => ({
                          ...prev,
                          status: e.target.value,
                        }))
                      }
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  ) : (
                    <input
                      type="text"
                      readOnly
                      value={prevProduct?.status || ""}
                    />
                  )}
                </div>

              </div>

              {/* installation card */}
              <label className="field-title">Installation Card</label>
              <div className="return-policy-toggle" style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", gap: "10px" }}>
                <div >
                  <input
                    className="return-checkbox"
                    style={{ width: "20px" }}
                    type="checkbox"
                    disabled={!isEditable}
                    checked={installationCard?.hasEnable}
                    onChange={(e) =>
                      setInstallationCard((pv) => ({
                        ...pv,
                        hasEnable: e.target.checked,
                      }))}
                  />
                  <label style={{ textWrap: "nowrap", paddingRight: "20px" }}>
                    Enable Installation Card
                  </label>
                </div>
                {installationCard?.hasEnable && (
                  <div style={{ gap: "1px" }}>
                    <input
                      type="number"
                      disabled={!isEditable}
                      value={installationCard?.price}
                      onChange={(e) => setInstallationCard((pv) => ({ ...pv, price: e.target.value }))}
                      placeholder="Installation Price"
                      className="return-days-input"
                    />
                    <textarea
                      type="text"
                      disabled={!isEditable}
                      value={installationCard?.desc}
                      onChange={(e) => setInstallationCard((pv) => ({ ...pv, desc: e.target.value }))}
                      placeholder="Installation Description"
                      className="return-days-input"
                    />
                  </div>
                )}
              </div>

              {isEditable && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <button
                    type="button"
                    onClick={() => updateprod(prevProduct?.product_id)}
                    style={{ maxWidth: "fit-content" }}
                  >
                    Update the Product
                  </button>
                </div>
              )}
            </div>

          </div>
        </>
      )}

      {Addmore && (
        <>
          <div className="modal-overlay" onClick={() => setAddmore(false)} />
          <div className="add-more-modal large">
            <h2>Add New Product</h2>
            <form>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "30px",
                }}
              >
                {/* LEFT: Image Upload */}
                <div>
                  <div
                    className="upload-box"
                    title="Click to upload image"
                    onClick={() => fileInputRef.current.click()}
                  >
                    {mainPreviewIndex !== null && previews[mainPreviewIndex] ? (
                      <div className="main-preview-wrapper">
                        <img
                          src={previews[mainPreviewIndex]}
                          alt="Selected preview"
                          className="main-preview-image"
                        />
                        <div className="preview-controls">
                          <button onClick={handleRemoveMainsPreview}>
                            Remove
                          </button>
                        </div>
                      </div>
                    ) : (
                      <>
                        <BsFolderPlus className="upload-icon" />
                        <p>Click to upload image</p>
                      </>
                    )}
                  </div>

                  <input
                    type="file"
                    accept="image/*,video/*,application/pdf"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                    multiple
                  />

                  {previews.length > 0 && (
                    <div className="preview-list">
                      {previews.map((src, i) => (
                        <div
                          key={i}
                          className="preview-thumb"
                          onClick={() => handleThumbnailClick(i)}
                          title="Click to set as main image"
                          style={{ cursor: "pointer" }}
                        >
                          <img src={src} alt={`preview-${i}`} />
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* RIGHT: Product Info */}
                <div style={{ width: "100%", maxWidth: "600px" }}>
                  <div className="row">
                    <div>
                      <label className="field-title">Category</label>
                      <select
                        value={newProduct.category || ""}
                        onChange={(e) =>
                          setNewProduct((prev) => ({
                            ...prev,
                            category: e.target.value,
                          }))
                        }
                      >
                        <option value="">Select Category</option>
                        <option value="electronics">Electronics</option>
                        <option value="fashion">Fashion</option>
                        <option value="grocery">Grocery</option>
                        <option value="home">Home</option>
                      </select>
                    </div>
                    <div>
                      <label className="field-title">Brand</label>
                      <input
                        type="text"
                        placeholder="Brand"
                        value={newProduct.brand || ""}
                        onChange={(e) =>
                          setNewProduct((prev) => ({
                            ...prev,
                            brand: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>

                  <label className="field-title">Product Name</label>
                  <input
                    type="text"
                    placeholder="Product Name"
                    value={newProduct.prod_name || ""}
                    onChange={(e) =>
                      setNewProduct((prev) => ({
                        ...prev,
                        prod_name: e.target.value,
                      }))
                    }
                    required
                  />

                  <label className="field-title">Product Description</label>
                  <textarea
                    className="textarea"
                    placeholder="Product Description"
                    value={newProduct.prod_desc || ""}
                    onChange={(e) =>
                      setNewProduct((prev) => ({
                        ...prev,
                        prod_desc: e.target.value,
                      }))
                    }
                    required
                  />

                  <label className="field-title">Product Features</label>
                  <textarea
                    className="textarea"
                    placeholder="Features"
                    value={newProduct.features || ""}
                    onChange={(e) =>
                      setNewProduct((prev) => ({
                        ...prev,
                        features: e.target.value,
                      }))
                    }
                  />

                  <label className="field-title">Keywords / Hashtags</label>
                  <textarea
                    className="textarea"
                    placeholder="Keywords like #summer #fashion"
                    value={newProduct.Keywords || ""}
                    onChange={(e) =>
                      setNewProduct((prev) => ({
                        ...prev,
                        Keywords: e.target.value,
                      }))
                    }
                  />
                </div>
              </div>

              {/* Size Pricing Table */}
              <div className="size-pricing-table">
                <h3 className="field-title">Price</h3>
                <div>
                  <button onClick={(e) => addRow(e, "new")} className="btn btn-success mb-2">
                    ➕ Add Size
                  </button>

                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Size</th>
                        <th>Original Price</th>
                        <th>Discount (%)</th>
                        <th>Discounted amount</th>
                        <th>Tax</th>
                        <th>Total Price</th>
                        <th>Stock</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {rows.length === 0 && (
                        <tr>
                          <td colSpan="8" className="text-center">
                            Click ➕ to add size
                          </td>
                        </tr>
                      )}

                      {rows.map((row, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              className="form-control"
                              value={row.size}
                              onChange={(e) =>
                                updateRow(index, "size", e.target.value)
                              }
                            />
                          </td>

                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={row.price}
                              onChange={(e) =>
                                updateRow(index, "price", e.target.value)
                              }
                            />
                          </td>

                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={row.discount}
                              onChange={(e) =>
                                updateRow(index, "discount", e.target.value)
                              }
                            />
                          </td>

                          <td>
                            <input
                              className="form-control"
                              readOnly
                              value={row.net}
                            />
                          </td>

                          <td>
                            <input
                              type="number"
                              className="form-control"
                              max={100}
                              min={0}
                              value={row.tax}
                              onChange={(e) =>
                                updateRow(index, "tax", e.target.value)
                              }
                            />
                          </td>

                          <td>
                            <input
                              className="form-control"
                              readOnly
                              value={row.total}
                            />
                          </td>

                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={row.stock}
                              onChange={(e) =>
                                updateRow(index, "stock", e.target.value)
                              }
                            />
                          </td>

                          <td className="text-center">
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => removeRow(index)}
                            >
                              ✖
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Second Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "30px",
                }}
              >
                <div style={{ width: "100%", maxWidth: "600px" }}>
                  <h3 className="field-title">Accepted Payment Methods</h3>
                  <div className="payment-grid">
                    {paymentOptions.map((option, index) => (
                      <label
                        key={index}
                        className={`payment-card ${selectedPayments.includes(option) ? "selected" : ""
                          }`}
                        onClick={() => toggleSelection(option)}
                      >
                        <input
                          type="checkbox"
                          checked={selectedPayments.includes(option)}
                          onChange={() => toggleSelection(option)}
                        />
                        {option}
                        {selectedPayments.includes(option) && (
                          <span className="checkmark">✔</span>
                        )}
                      </label>
                    ))}
                  </div>

                  <label className="field-title">Return Policy</label>
                  <div className="return-policy-toggle">
                    <input
                      className="return-checkbox"
                      type="checkbox"
                      checked={hasReturn}
                      onChange={(e) => setHasReturn(e.target.checked)}
                    />
                    <label style={{ textWrap: "nowrap", paddingRight: "20px" }}>
                      Enable Returns
                    </label>
                    {hasReturn && (
                      <input
                        type="number"
                        min={1}
                        max={30}
                        value={returnDays}
                        onChange={(e) => setReturnDays(e.target.value)}
                        placeholder="Return Policy Days"
                        className="return-days-input"
                      />
                    )}
                  </div>
                </div>

                <div style={{ width: "100%", maxWidth: "600px" }}>
                  <label className="field-title">Delivery Time (in Days)</label>
                  <input
                    type="number"
                    max={20}
                    min={1}
                    placeholder="e.g. 3, 5"
                    value={newProduct.delivery_time || ""}
                    onChange={(e) =>
                      setNewProduct((prev) => ({
                        ...prev,
                        delivery_time: e.target.value,
                      }))
                    }
                  />

                  <label className="field-title">Product Status</label>
                  <select
                    value={newProduct.status || "active"}
                    onChange={(e) =>
                      setNewProduct((prev) => ({
                        ...prev,
                        status: e.target.value,
                      }))
                    }
                  >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
              </div>

              {/* installation card */}

              <label className="field-title">Installation Card</label>
              <div className="return-policy-toggle" style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", gap: "10px" }}>
                <div >
                  <input
                    className="return-checkbox"
                    style={{ width: "20px" }}
                    type="checkbox"
                    checked={hasinstallationCard}
                    onChange={(e) => setHasinstallationCard(e.target.checked)}
                  />
                  <label style={{ textWrap: "nowrap", paddingRight: "20px" }}>
                    Enable Installation Card
                  </label>
                </div>
                {hasinstallationCard && (
                  <div style={{ gap: "1px" }}>
                    <input
                      type="number"
                      value={installationCardInfo?.price}
                      onChange={(e) => setInstallationCardInfo((pv) => ({ ...pv, price: e.target.value }))}
                      placeholder="Installation Price"
                      className="return-days-input"
                    />
                    <textarea
                      type="text"
                      value={installationCardInfo?.desc}
                      onChange={(e) => setInstallationCardInfo((pv) => ({ ...pv, desc: e.target.value }))}
                      placeholder="Installation Description"
                      className="return-days-input"
                    />
                  </div>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <button
                  type="button"
                  onClick={addProduct}
                  style={{ maxWidth: "fit-content" }}
                >
                  Make It Live
                </button>
              </div>
            </form>
          </div>
        </>
      )}
    </div>
  );
}

export default Products;
